import Angular from "angular";
import Template from "./wheel-storage-state-icon.html";

export default Angular.module('wheel-storage-state-icon', [])
    .component('wheelStorageStateIcon', {
        template: Template,
        bindings: {
            storageState: '<',
            withLabel: '@'
        },
    })



// WEBPACK FOOTER //
// ./src/modules/main/components/wheel-storage-state-icon/wheel-storage-state-icon.js